import { ShimmerBadge, ShimmerSimpleGallery } from "react-shimmer-effects";

const ThreeColsStatsLoading = () => {
  return (
    <div className=" rounded-lg bg-white shadow-lg p-3">
      <ShimmerBadge width={300} />
      <ShimmerSimpleGallery
        className="mb-0"
        row={1}
        col={3}
        imageType={"thumbnail"}
        imageHeight={120}
        gap={30}
      />
    </div>
  );
};

export default ThreeColsStatsLoading;
